export default __webpack_public_path__ + "static/media/setup-wizard.24f939ce.svg";